module.exports = __webpack_public_path__ + "static/media/r37.de8323b7.jfif";